import React, { useEffect, useState } from "react";
import { fetchWithAuth } from "../utils/fetchWithAuth";
import { SERVER_URL } from "../config";

interface Prescription {
  id: string;
  prescriptionNumber: string;
  medication: { name: string };
  dosage: string;
  strength: string;
  quantity: number;
  status: string;
  createdAt: string;
}

interface ProviderPrescriptionsProps {
  providerId: string;
}

const ProviderPrescriptions: React.FC<ProviderPrescriptionsProps> = ({
  providerId,
}) => {
  const batchSize = 5;
  const [prescriptions, setPrescriptions] = useState<Prescription[]>([]);
  const [offset, setOffset] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchPage = async (off: number) => {
    setLoading(true);
    try {
      const res = await fetchWithAuth(
        `${SERVER_URL}/api/prescription/provider-prescriptions?providerId=${providerId}&limit=${batchSize}&offset=${off}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      if (!res.ok) throw new Error("Fetch failed");
      const body: { data: Prescription[]; hasMore: boolean } = await res.json();
      setPrescriptions((prev) => [...prev, ...body.data]);
      setHasMore(body.hasMore);
      setOffset(off + batchSize);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (providerId) {
      setPrescriptions([]);
      setOffset(0);
      setHasMore(true);
      fetchPage(0);
    }
  }, [providerId]);

  if (error) return <p style={{ color: "red" }}>{error}</p>;

  return (
    <div className="provider-prescriptions-container">
      {hasMore && (
        <button
          onClick={() => fetchPage(offset)}
          disabled={loading}
          className="load-more-button"
        >
          {loading ? "Loading…" : "Load more"}
        </button>
      )}
      <div className="prescriptions-table-scroll">
        <table className="prescriptions-table">
          <thead>
            <tr>
              <th>RX#</th>
              <th>Medication</th>
              <th>Dosage</th>
              <th>Strength</th>
              <th>Qty</th>
              <th>Status</th>
              <th>Created</th>
            </tr>
          </thead>
          <tbody>
            {prescriptions.map((p) => (
              <tr key={p.id}>
                <td>{p.prescriptionNumber}</td>
                <td>{p.medication.name}</td>
                <td>{p.dosage}</td>
                <td>{p.strength}</td>
                <td>{p.quantity}</td>
                <td>{p.status}</td>
                <td>{new Date(p.createdAt).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ProviderPrescriptions;
